import React, { useEffect, useState } from "react";
import { Button } from "antd";
import Main from "../../components/layout/Main";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import { useNavigate } from "react-router";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTournament } from "../../context/TournamentContext";
import moment from "moment";
import { getDiff, isValidUrl } from "../../helper/functions";
import { ImageNotAvailable } from "../../constants/urls";
import { useAuth } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";
// // ------------------- Not Available Image Url -----------------------
// const ImageNotAvailable =
//   "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png";

const LiveTournament = () => {
  const [tournaments, setTournaments] = useState([]);
  const [games, setGames] = useState([]);
  const navigate = useNavigate();
  const [profile, setProfile] = useState();
  const location = useLocation();

  const { loadTournaments, updateFilters, loadGames } = useTournament();
  const { getProfile } = useAuth();

  // ----------   handlers   -----------
  const fetchTournaments = async (params = {}) => {
    const profileData = await getProfile();
    if (profileData.status === 200) {
      setProfile(profileData.data);
    }

    const response = await loadTournaments(params);
    if (response?.status === 200) {
      setTournaments(response.data.data.tournaments);
    }

    const result = await loadGames();
    if (result.status === 200) {
      setGames(result.data.data.uncategorizedGames);
    }
  };

  // ---------- use effects ----------
  useEffect(() => {
    const params = { status: "Active", type: "public", game: "" };
    updateFilters(params);
    fetchTournaments(params);
  }, []);

  return (
    <Main>
      <div className="section-headding">
        <h6>Live Tournaments</h6>
      </div>
      <div className="home-container">
        <Section
          title="Browse by Games"
          data={games}
          type="game"
          navigate={navigate}
          profile={profile}
        />
        <Section
          data={tournaments}
          type="tournament"
          navigate={navigate}
          profile={profile}
        />
      </div>
    </Main>
  );
};

const Section = ({ title, data, type, navigate, profile }) => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 4, // ek time me 4 item
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // small mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="section-block">
      {type === "tournament" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
          </div>
          <div className="main-grid-class">
            {data?.map((item, index) => {
              console.log("live tournament item-->", item);
              return (
                <div
                  key={index}
                  className="tournament-card"
                  onClick={() =>
                    navigate(
                      `/live-tournaments/tournaments-details/${item._id}`
                    )
                  }
                >
                  <div className="tunament-image">
                    <img
                      alt="thumbnail"
                      src={
                        isValidUrl(item?.game?.image)
                          ? item.game.image
                          : ImageNotAvailable
                      }
                    />
                  </div>

                  <div className="card-top-info">
                    <div className="tunament-date">
                      {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                    </div>
                    <div className="starts-time">
                      {/* <span>{getDiff(item.startDate, new Date())}</span> */}
                      {item.type}
                    </div>
                  </div>

                  <div className="card-tags">
                    <img src={TrofiesImage} alt="Trophies" />
                    {item.trophyStructure &&
                      item.trophyStructure.map((trophy, index) => (
                        <span key={index}>{trophy}</span>
                      ))}
                  </div>

                  <div className="live-tournament-name-div">
                    <p>{item?.name_en}</p>
                  </div>

                  <div className="tunament-slot">{`${
                    item.totalRegisteredPlayers
                  }/ ${
                    item?.teamSize *
                    (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                  } slots`}</div>

                  <div className="brouse-game-live-btn">
                    {/* {profile?.isSubscribed ? (
                    <Button
                      className="join-button Fill-button"
                      onClick={() =>
                        navigate(
                          `/live-tournaments/tournaments-details/${item._id}`
                        )
                      }
                    >
                      Join Tournament
                    </Button>
                  ) : (
                    <>
                      <Button
                        className="join-button Fill-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/subscriptions");
                        }}
                      >
                        Upgrade To Premium
                      </Button>
                    </>
                  )} */}

                    <Button
                      className="join-button Fill-button"
                      onClick={() =>
                        navigate(
                          `/live-tournaments/tournaments-details/${item._id}`
                        )
                      }
                    >
                      View Brackets
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : type === "game" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
            <span
              className="view-all"
              onClick={() => navigate("/live-tournaments/games")}
            >
              {data && " View All "}
            </span>
          </div>

          <div className="browse-game-slide">
            {data && data.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                navigation={true}
                loop={true}
                speed={500}
                spaceBetween={20}
                breakpoints={{
                  480: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
              >
                {data.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="game-card"
                      // onClick={() => navigate("/live-tournaments/games")}
                      onClick={() =>
                        navigate(
                          `/live-tournaments/games/${item?.game?.name}?tab=Active`
                        )
                      }
                    >
                      {/* IMAGE */}
                      <img
                        src={
                          isValidUrl(item?.game?.image)
                            ? item?.game?.image
                            : ImageNotAvailable
                        }
                        alt={item?.game?.name || "Game"}
                        className="game-image"
                      />

                      <div className="card-top-info">
                        <div className="tunament-date">
                          {item?.game?.name ?? "Unknown Game"}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="no-games-available">
                <p>No games available</p>
              </div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default LiveTournament;
